export const mainUrl = "https://api.bossblog.uz/api/v1";
